import React from 'react'
import { SimpleMessagePage } from '../../components'

const SoldOut: React.FC = () => <SimpleMessagePage messageKey="soldOut" />

export default SoldOut
